import { SuggestedAction } from '@app/models'

import { ThreadMessageReceivedEvent } from '../../types'

export const mapSuggestedActionFromEvent = (
  event: ThreadMessageReceivedEvent
): SuggestedAction | null => {
  const suggestedActionId = Number(event.metadata.SuggestedActionId)
  const toParticipantId = Number(event.metadata.ToParticipantId)
  const creationDate = event.metadata.CreationDate
  const updateDate = event.metadata.UpdateDate || creationDate

  return {
    id: suggestedActionId,
    creationDate,
    updateDate,
    toParticipantId,
    type: event.metadata.SuggestedActionsType || 'Reminder',
    status: event.metadata.SuggestedActionsStatus || 'Pending',
  }
}
